import { memo, useMemo } from 'react';
import Stack from '@mui/material/Stack';
//
import { NavListProps, NavConfigProps, NavSectionProps } from '../types';
import { useNavMiniConfig } from '../config';
import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionMini({ data, config, sx, ...other }: NavSectionProps) {
  const navConfig = useNavMiniConfig(config);

  const renderGroups = useMemo(
    () =>
      data.map((group, index) => (
        <Group key={group.subheader || index} items={group.items} config={navConfig} />
      )),
    [data, navConfig]
  );

  return (
    <Stack sx={sx} {...other}>
      {renderGroups}
    </Stack>
  );
}

export default memo(NavSectionMini);

// ----------------------------------------------------------------------

type GroupProps = {
  items: NavListProps[];
  config: NavConfigProps;
};

function Group({ items, config }: GroupProps) {
  const renderItems = useMemo(
    () =>
      items.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={1}
          hasChild={!!list.children}
          config={config}
        />
      )),
    [items, config]
  );

  return <>{renderItems}</>;
}
